import React from 'react';
import _ from 'lodash';

import { Anchor, Center, Text } from '@good/ui/core';
import { GoodTable } from '@good/ui/templates';
import moment from 'moment';
import { ArrowTopRight } from '@good/icons';
import { rosterConfig } from '../../roster-config';

export function HeaderRow({ days, onClickDay }: { days: Date[]; onClickDay: (day: Date) => void }) {
  return (
    <GoodTable.Thead>
      <GoodTable.Th sticky bg={rosterConfig.grayColor} />
      {days.map((day) => (
        <GoodTable.Th key={day.toString()} miw={240} bg={rosterConfig.grayColor}>
          <Center w='100%'>
            <Anchor c='dark' onClick={() => onClickDay(day)} size='sm' tt='capitalize'>
              {moment(day).format('dddd')}{' '}
              <Text span inherit fw={650} mr='xs'>
                {moment(day).format('D MMM')}
              </Text>
              <ArrowTopRight />
            </Anchor>
          </Center>
        </GoodTable.Th>
      ))}
    </GoodTable.Thead>
  );
}
